module.exports = __webpack_public_path__ + "static/img/14.4115e82.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/14.png
// module id = 7Lqw
// module chunks = 0